import NewsletterCard from './NewsletterCard';

export default NewsletterCard;
